module.exports = __webpack_public_path__ + "img/prop-shopping-1-left.8d46354a.png";